/* eslint-disable max-lines-per-function */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { KeyboardEvent, useState } from 'react';
import { Input } from '../../../../components/Input';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { Drawer } from '../../../../components/Drawer';
import {
    classes,
    toLazyObservablePromise,
    useLoadingState,
    useRedirect,
} from '../../../../lib';
import { Button, Empty } from 'antd';
import Styles from './TrainingSeach.module.less';
import {
    TrainingContentType,
    TrainingDataType,
    useSanity,
} from '../../../../lib/landingPage';
import { Card } from '../../../../components/Card';
import { Loading } from '../../../../components/Loading';
import {
    TRAINING_URL,
    getMenuItemPath,
} from '../../../../lib/landingPage/training';
import { Form, FormItem } from '../../../../components/FormItem';

type TrainingSearchProps = {
    visible: boolean;
    hide: VoidFunction;
    trainingMenu: TrainingDataType;
};

// eslint-disable-next-line complexity
export const TrainingSearch = ({
    visible,
    hide,
    trainingMenu,
}: TrainingSearchProps): JSX.Element => {
    const sanityStore = useSanity();
    const container = React.useRef<HTMLDivElement>(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResult, setSearchResult] = useState<TrainingContentType[]>([]);
    const [, setLoading, isLoading] = useLoadingState();
    const [lastSearchQuery, setLastSearchQuery] = useState('');
    const redirect = useRedirect();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(event.target.value);
    };

    const runSearchQuery = () => {
        if (searchQuery !== '') {
            setLoading(
                toLazyObservablePromise(
                    sanityStore.asyncSearchTraining(searchQuery)
                )
            ).then((result: TrainingContentType[]) => {
                setSearchResult(result);
                setLastSearchQuery(searchQuery);
            });
        } else {
            setSearchResult([]);
            setLastSearchQuery(searchQuery);
        }
    };

    const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            runSearchQuery();
        }
    };

    const getItemName = (slug: string) => {
        const items = getMenuItemPath(trainingMenu, slug);

        return items.map((item, index: number) => (
            <span key={index}>
                {index === items.length - 1 ? (
                    <strong>{item.title}</strong>
                ) : (
                    <span className="alude-storm-6">{item.title + ' > '}</span>
                )}
            </span>
        ));
    };

    const hideAndDestroy = () => {
        hide();
        setSearchQuery('');
        setSearchResult([]);
        setLastSearchQuery('');
    };

    return (
        <Drawer
            title={<span>Procure por um tópico</span>}
            visible={visible}
            closable
            onClose={hideAndDestroy}
            width={500}>
            <div
                className={classes(
                    'vertical stretch-top px16 pb16 pt32 g24',
                    Styles.bodyContainer
                )}
                ref={container}>
                <Form className={Styles.form} layout="vertical">
                    <FormItem
                        className={Styles.formItem}
                        label="Digite sua pesquisa"
                        name="query">
                        <div className="td-horizontal m-vertical g8">
                            <Input
                                style={{ flex: '1 1 auto' }}
                                placeholder="Procure por uma palavra chave"
                                onChange={handleChange}
                                value={searchQuery}
                                onKeyPress={handleKeyPress}
                                prefix={<FontAwesomeIcon icon={faSearch} />}
                            />
                            <Button
                                onClick={runSearchQuery}
                                type="primary"
                                loading={isLoading()}>
                                Pesquisar
                            </Button>
                        </div>
                    </FormItem>
                </Form>
                <div className="vertical g12">
                    {lastSearchQuery && !isLoading() && (
                        <b>Resultados encontrados</b>
                    )}
                    <Card borderInBetween>
                        {isLoading() ? (
                            <div className="vertical g8 center-middle p32">
                                <Loading />
                                <div>Buscando resultados</div>
                            </div>
                        ) : (
                            <>
                                {searchResult.map(({ slug }, index) => (
                                    <div
                                        onClick={() => {
                                            redirect(
                                                `${TRAINING_URL()}/${
                                                    slug.current
                                                }`
                                            );
                                            hideAndDestroy();
                                        }}
                                        key={index}
                                        className={classes(
                                            'p16 pointer',
                                            Styles.searchCard
                                        )}>
                                        {getItemName(slug.current)}
                                    </div>
                                ))}
                                {searchResult.length === 0 && (
                                    <div className="m-p16 td-p32">
                                        <Empty
                                            description={
                                                lastSearchQuery
                                                    ? 'Nenhum resultado'
                                                    : 'Digite um termo para busca e pressione o botão "Pesquisar"'
                                            }
                                        />
                                    </div>
                                )}
                            </>
                        )}
                    </Card>
                </div>
            </div>
        </Drawer>
    );
};
